module.exports = __webpack_public_path__ + "static/media/panCorrect.f429a038.png";